import { Occupation } from 'api/general/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<Occupation>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const occupationsReducer = createReducer<State, Actions>(initialState, {
  [actions.getOccupations.request.type]: actionsHandlers.handleGetPaginatedManyRequest,
  [actions.getOccupations.success.type]: actionsHandlers.handleGetPaginatedManySuccess,
  [actions.getOccupations.failure.type]: actionsHandlers.handleGetPaginatedManyFailure,
  [actions.getOccupations.reset.type]: actionsHandlers.handleGetPaginatedManyReset,
});

export default occupationsReducer;
